module.exports = __webpack_public_path__ + "static/media/Stake_n.92d7dda0.png";